export default "__VITE_ASSET__BuYuZcEP__"